export const CLEAR_DIALOGS = 'CLEAR_DIALOGS';

export const clearDialogs = () => ({
  type: CLEAR_DIALOGS
});
